import { service } from '@ember/service';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { getOwner } from '@ember/application';
import { isTesting, macroCondition } from '@embroider/macros';

export default class ApplicationController extends Controller {
  @tracked isLoading = false;
  @tracked showLogoutWarningModal = false;
  #authToken;

  @service currentUser;
  @service session;
  @service router;

  // eslint-disable-next-line no-unneeded-ternary
  isTesting = macroCondition(isTesting()) ? true : false;

  get isIntegrationTesting() {
    return globalThis.isIntegrationTest;
  }

  @action
  confirmLogoutWarning() {
    this.showLogoutWarningModal = false;
    getOwner(this).lookup('authenticator:jwt').refreshAccessToken(this.#authToken);
    this.#authToken = null;
  }

  @action
  logout() {
    this.showLogoutWarningModal = false;
    return this.session.invalidate();
  }

  onCloseLogoutWarningModal() {
    if (!this.showLogoutWarningModal) {
      return;
    }

    this.showLogoutWarningModal = false;
    this.#authToken = null;
  }

  onShowLogoutWarningModal(token) {
    if (this.showLogoutWarningModal) {
      return;
    }

    this.#authToken = token;
    this.showLogoutWarningModal = true;
  }
}
